import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { TextField, InputAdornment } from "@mui/material";
import Swal from "sweetalert2";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import { LoaderScreen } from "../../../components/LoaderScreen";
import request from "../../../../Helpers/API";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import EditIcon from "@mui/icons-material/Edit";
import SearchIcon from "@mui/icons-material/Search";
import { MultiplicadorPiezaModal } from "./MultiplicadorPiezaModal";

// Listado del catálogo Parte-Multiplicador (Postventa / Reporte de
// Refacciones / Multiplicadores de Piezas). Alta y edición se hacen con
// MultiplicadorPiezaModal; el listado se recarga cada vez que el modal se
// cierra. Mismo patrón que VendedoresEquipScreen.js.
const MultiplicadorPiezasScreen = () => {
    const history = useHistory();

    const [listado, setListado] = useState([]);
    const [busqueda, setBusqueda] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [registroEditar, setRegistroEditar] = useState(null);
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const cargarListado = () => {
        setLoader((prev) => ({ ...prev, mostrar: true }));
        request
            .get("MultiplicadorPieza/Listado")
            .then((result) => {
                setListado(result || []);
                setLoader((prev) => ({ ...prev, mostrar: false }));
            })
            .catch(() => {
                setLoader((prev) => ({ ...prev, mostrar: false }));
                Swal.fire(
                    "MULTIPLICADOR DE PIEZAS",
                    "No fue posible cargar el listado. Intente nuevamente o contacte al administrador.",
                    "error"
                );
            });
    };

    // Recarga el listado cada vez que el modal se cierra (después de agregar/editar).
    useEffect(() => {
        if (openModal) return;
        cargarListado();
    }, [openModal]);

    const onAgregar = () => {
        setRegistroEditar(null);
        setOpenModal(true);
    };

    const onEditar = (registro) => {
        setRegistroEditar(registro);
        setOpenModal(true);
    };

    const onCerrarModal = () => {
        setOpenModal(false);
        setRegistroEditar(null);
    };

    // Búsqueda en memoria por parte o multiplicador (el endpoint no acepta parámetro de búsqueda).
    const listadoFiltrado = listado.filter((fila) => {
        if (!busqueda.trim()) return true;
        const texto = busqueda.trim().toLowerCase();
        return (
            String(fila.parte || "").toLowerCase().includes(texto) ||
            String(fila.multiplicador ?? "").toLowerCase().includes(texto)
        );
    });

    return (
        <PlantillaScreen
            titulo={"MULTIPLICADOR DE PIEZAS"}
            className={"multiplicador-piezas-main-screen"}
            className_main={1}
        >
            <LoaderScreen loader={loader} />
            <div className="mpz-actions">
                <div className="mpz-actions-regresar" onClick={() => history.goBack()}>
                    <ArrowBackIcon /> Regresar
                </div>
            </div>

            <div className="mpz-container">
                <div className="mpz-header">
                    <TextField
                        className="mpz-buscador"
                        size="small"
                        label="Buscar"
                        placeholder="Parte o multiplicador..."
                        value={busqueda}
                        onChange={({ target }) => setBusqueda(target.value)}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                        }}
                    />
                    <button className="mpz-agregar" onClick={onAgregar} type="button">
                        <AddCircleOutlineIcon /> Agregar
                    </button>
                </div>

                <div className="mpz-tabla scroll-4">
                    <table cellPadding={0} cellSpacing={0}>
                        <thead>
                            <tr>
                                <th>Parte</th>
                                <th>Multiplicador</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {listadoFiltrado.length === 0 ? (
                                <tr>
                                    <td colSpan={3} className="mpz-vacio">
                                        Sin registros para mostrar.
                                    </td>
                                </tr>
                            ) : (
                                listadoFiltrado.map((fila) => (
                                    <tr key={fila.idparte}>
                                        <td>{fila.parte}</td>
                                        <td>{fila.multiplicador}</td>
                                        <td className="mpz-columna-editar">
                                            <div className="mpz-boton-editar" onClick={() => onEditar(fila)}>
                                                <EditIcon /> Editar
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            <MultiplicadorPiezaModal
                open={openModal}
                registro={registroEditar}
                onClose={onCerrarModal}
                onGuardado={cargarListado}
            />
        </PlantillaScreen>
    );
};

export default MultiplicadorPiezasScreen;
